
import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Badge,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    Label,
    FormFeedback,
} from "reactstrap"
import { connect } from "react-redux"
import { useFormik } from "formik"
import * as Yup from "yup"

//Import Action
import {
    setBreadcrumbItems,
    getSystemUsers,
    addNewSystemUser,
    updateSystemUser,
    deleteSystemUser,
    getRoles,
} from "../../../store/actions"

const SystemUsersList = (props) => {
    document.title = "Gestion de l'Équipe | CRM Admin";

    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [currentUser, setCurrentUser] = useState(null)

    const breadcrumbItems = [
        { title: "CRM", link: "#" },
        { title: "Admin", link: "#" },
        { title: "Staff Super Admin", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Équipe Admin", breadcrumbItems)
        props.getSystemUsers()
        props.getRoles()
    }, [])

    const toggle = () => {
        if (modal) {
            setModal(false)
            setCurrentUser(null)
            setIsEdit(false)
        } else {
            setModal(true)
        }
    }

    const handleUserClick = arg => {
        const user = arg
        setCurrentUser({
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            phone: user.phone || "",
            status: user.status,
            role_id: user.roles && user.roles.length > 0 ? user.roles[0].id : "",
        })
        setIsEdit(true)
        toggle()
    }

    const handleDeleteUser = userId => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce membre de l'équipe ?")) {
            props.deleteSystemUser(userId)
        }
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            first_name: (currentUser && currentUser.first_name) || "",
            last_name: (currentUser && currentUser.last_name) || "",
            email: (currentUser && currentUser.email) || "",
            phone: (currentUser && currentUser.phone) || "",
            status: (currentUser && currentUser.status) || "active",
            role_id: (currentUser && currentUser.role_id) || "",
            password: "",
            password_confirmation: "",
        },
        validationSchema: Yup.object({
            first_name: Yup.string().required("Prénom requis"),
            last_name: Yup.string().required("Nom requis"),
            email: Yup.string().email("Email invalide").required("Email requis"),
            role_id: Yup.string().required("Rôle requis"),
            password: Yup.string().when('isEdit', {
                is: false,
                then: () => Yup.string().min(8, "8 caractères minimum").required("Mot de passe requis"),
                otherwise: () => Yup.string().min(8, "8 caractères minimum")
            }),
            password_confirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Les mots de passe doivent correspondre')
        }),
        onSubmit: values => {
            if (isEdit) {
                const updateUserData = {
                    id: currentUser.id,
                    ...values,
                }
                props.updateSystemUser(updateUserData)
            } else {
                props.addNewSystemUser(values)
            }
            toggle()
        },
    })

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <CardTitle className="h4 mb-0">Gestion de l'Équipe Super Admin</CardTitle>
                                <Button color="primary" onClick={toggle}>
                                    <i className="mdi mdi-plus me-1"></i> Ajouter un Membre
                                </Button>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-centered table-nowrap mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Nom Complet</th>
                                            <th>Rôle</th>
                                            <th>Email</th>
                                            <th>Téléphone</th>
                                            <th>Date d'ajout</th>
                                            <th>Statut</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(props.users || []).map((user, key) => (
                                            <tr key={key}>
                                                <td>{user.first_name} {user.last_name}</td>
                                                <td>
                                                    {user.roles && user.roles.length > 0 ? (
                                                        <span className="badge badge-soft-primary font-size-12 px-2 py-1">
                                                            {user.roles[0].name}
                                                        </span>
                                                    ) : (
                                                        <span className="text-muted italic">Sans rôle</span>
                                                    )}
                                                </td>
                                                <td>{user.email}</td>
                                                <td>{user.phone || "N/A"}</td>
                                                <td>{new Date(user.created_at).toLocaleDateString()}</td>
                                                <td>
                                                    <span
                                                        className={user.status === 'active' ? 'badge badge-soft-success font-size-11 px-2 py-1' : 'badge badge-soft-danger font-size-11 px-2 py-1'}
                                                    >
                                                        {user.status === 'active' ? 'Actif' : 'Inactif'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            color="primary"
                                                            size="sm"
                                                            onClick={() => handleUserClick(user)}
                                                        >
                                                            <i className="mdi mdi-pencil"></i>
                                                        </Button>
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            onClick={() => handleDeleteUser(user.id)}
                                                        >
                                                            <i className="mdi mdi-trash-can"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle} tag="h4">
                    {!!isEdit ? "Modifier le Membre" : "Ajouter un Membre"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Prénom</Label>
                                    <Input
                                        name="first_name"
                                        type="text"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.first_name || ""}
                                        invalid={validation.touched.first_name && validation.errors.first_name ? true : false}
                                    />
                                    {validation.touched.first_name && validation.errors.first_name ? (
                                        <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Nom</Label>
                                    <Input
                                        name="last_name"
                                        type="text"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.last_name || ""}
                                        invalid={validation.touched.last_name && validation.errors.last_name ? true : false}
                                    />
                                    {validation.touched.last_name && validation.errors.last_name ? (
                                        <FormFeedback type="invalid">{validation.errors.last_name}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Email</Label>
                                    <Input
                                        name="email"
                                        type="email"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.email || ""}
                                        invalid={validation.touched.email && validation.errors.email ? true : false}
                                    />
                                    {validation.touched.email && validation.errors.email ? (
                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Téléphone</Label>
                                    <Input
                                        name="phone"
                                        type="text"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.phone || ""}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <hr />

                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>{isEdit ? "Changer le Mot de passe (optionnel)" : "Mot de passe"}</Label>
                                    <Input
                                        name="password"
                                        type="password"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.password || ""}
                                        invalid={validation.touched.password && validation.errors.password ? true : false}
                                    />
                                    {validation.touched.password && validation.errors.password ? (
                                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Confirmer le Mot de passe</Label>
                                    <Input
                                        name="password_confirmation"
                                        type="password"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.password_confirmation || ""}
                                        invalid={validation.touched.password_confirmation && validation.errors.password_confirmation ? true : false}
                                    />
                                    {validation.touched.password_confirmation && validation.errors.password_confirmation ? (
                                        <FormFeedback type="invalid">{validation.errors.password_confirmation}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Rôle</Label>
                                    <Input
                                        name="role_id"
                                        type="select"
                                        className="form-select"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.role_id || ""}
                                        invalid={validation.touched.role_id && validation.errors.role_id ? true : false}
                                    >
                                        <option value="">Sélectionner un rôle</option>
                                        {(props.roles || []).filter(r => r.type === 'system').map((role, i) => (
                                            <option key={i} value={role.id}>{role.name}</option>
                                        ))}
                                    </Input>
                                    {validation.touched.role_id && validation.errors.role_id ? (
                                        <FormFeedback type="invalid">{validation.errors.role_id}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Statut</Label>
                                    <Input
                                        name="status"
                                        type="select"
                                        className="form-select"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.status || "active"}
                                    >
                                        <option value="active">Actif</option>
                                        <option value="inactive">Inactif</option>
                                        <option value="suspended">Suspendu</option>
                                    </Input>
                                </div>
                            </Col>
                        </Row>

                        <div className="text-end mt-4">
                            <Button type="button" color="secondary" className="me-2" onClick={toggle}>Annuler</Button>
                            <Button type="submit" color="success">
                                {isEdit ? "Mettre à jour" : "Ajouter au Staff"}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        users: state.SystemUsers.users,
        roles: state.Roles.roles,
    }
}

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getSystemUsers,
    addNewSystemUser,
    updateSystemUser,
    deleteSystemUser,
    getRoles,
})(SystemUsersList)
